import {ShowModeFromQuery} from "../../Misc/Query";
import {SearchFilter} from "../SearchFilters/SearchFilters";
import {DefaultSearchQuery} from "../SearchFilters/QueryFromFilters";

export class SearchInCurrentRun {
    constructor(owner, runId, location, history) {
        this._owner = owner;
        this._runId = runId;
        this._location = location;
        this._history = history;
    }

    addSearchHandlerSchemaTo(searchContext) {
        searchContext.addSearchHandlerSchema(
            {
                owner: this._owner,
                searchType: 'search_in_current_run',
                handler: (query, settings) => {
                    const filters = [];
                    const showMode = new ShowModeFromQuery(this._location.search);

                    const searchFilter = new SearchFilter('', query, 'Search', settings.useWildcards);

                    searchFilter.addTo(filters);

                    this._history.push({
                        pathname: `/user_view/explore_results/${this._runId}`,
                        search: new DefaultSearchQuery(filters, 1, showMode.getValue()).toString()
                    });
                }
            }
        );
    }
}